import React, { useState } from 'react';
import { useShop } from './ShopContext';
import { money, media, Select } from './ui';

export default function SoapBundle({ id = 'bundle' }) {
  const { products, settings, add, lang } = useShop();
  const [selected, setSelected] = useState(['', '', '']);
  const options = products.filter(p => p.type === 'soap').flatMap(p => p.variants.filter(v => v.stock > 0).map(v => ({ key: p.id + ':' + v.id, p, v })));
  const valid = selected.every(Boolean) && selected.every(k => { const o = options.find(o => o.key === k); return o && selected.filter(x => x === k).length <= o.v.stock; });
  const addBundle = () => add({ kind: 'soap_bundle', scents: selected.map(k => {
    const o = options.find(o => o.key === k);
    return { product_id: o.p.id, variant_id: o.v.id };
  }) }, 'Lot de 3 savons — ' + selected.map(k => options.find(o => o.key === k).p.name).join(', '), options.find(o => o.key === selected[0])?.p.images[0]);
  return <div className="s-stack">
    <div className="flex gap-4 items-center flex-wrap">
      <h2 className="s-subtitle">{lang === 'fr' ? 'Votre lot de trois savons au choix' : 'Your choice of three soaps'}</h2>
      <span data-testid={`${id}-price`} className="text-xl">{money(settings.soap_bundle_price)}</span>
    </div>
    {!options.length ? <p data-testid={`${id}-empty`} className="s-muted">{lang === 'fr' ? 'Les senteurs sont momentanément indisponibles.' : 'Scents are temporarily unavailable.'}</p> : <>
      <div className="s-soap-grid">{selected.map((value, i) => {
        const o = options.find(o => o.key === value);
        return <div key={i} className="s-stack">
          <div className="aspect-square bg-[#eee6d9] grid place-items-center">
            {o?.p.images[0] ? <img data-testid={`${id}-image-${i}`} src={media(o.p.images[0])} alt={o.p.name} className="w-full h-full object-contain" /> : <span className="font-serif text-4xl text-[#b09567]">0{i + 1}</span>}
          </div>
          <Select label={`${lang === 'fr' ? 'Savon' : 'Soap'} ${i + 1}`} id={`${id}-scent-${i}`} value={value} onChange={v => setSelected(a => a.map((x, j) => i === j ? v : x))}>
            <option value="">{lang === 'fr' ? 'Choisir une senteur' : 'Choose a scent'}</option>
            {options.map(o => <option key={o.key} value={o.key} disabled={selected.filter((x, j) => j !== i && x === o.key).length >= o.v.stock}>{`${lang === 'en' ? o.p.name_en || o.p.name : o.p.name} · ${o.v.label}`}</option>)}
          </Select>
        </div>;
      })}</div>
      <button className="s-button self-start" data-testid={`${id}-add`} disabled={!valid} onClick={addBundle}>{lang === 'fr' ? 'Ajouter le lot au panier' : 'Add bundle to basket'} · {money(settings.soap_bundle_price)}</button>
    </>}
  </div>;
}